import {CommandStatus} from '../../models/command-response';
import {PanelOutputGroup} from '../../models/panel-output-group';
import {PanelOutput} from '../../models/panel-output.interface';
import {PushNotificationSettings} from '../../models/signalr-query-result.interface';

export class PanelOutputsStateModel {
  userPanelOutputs: PanelOutput[];
  error: Error;
  selectedPanelOutput: PanelOutput;
  selectedPanelOutputGroup: PanelOutputGroup;
  commandStatus: CommandStatus;
  searchTerm: string;
  statusChangeConnection: PushNotificationSettings;
}

